import { inject, Service } from '@angular/core';
import dayjs from 'dayjs/esm';

import { UserBeanService } from '@services';

@Service()
export class UserKeepAliveService {
  userBeanService = inject(UserBeanService);

  lastRequestDate: Nullable<dayjs.Dayjs> = null;

  keepAliveUserSession = (requestDate: dayjs.Dayjs) => {
    this.lastRequestDate = requestDate;
    this.userBeanService.keepAlive();
  };

  keepAlive = () => {
    const requestDate = dayjs();

    if (
      this.lastRequestDate !== null &&
      requestDate.diff(this.lastRequestDate, 'minute') >= 5
    ) {
      this.keepAliveUserSession(requestDate);
    } else if (this.lastRequestDate === null) {
      this.keepAliveUserSession(requestDate);
    }
  };
}
